// One Socket.IO connection for the page.
//
// There were two: QueueFiles opened one, and every BusyCard it rendered opened
// another. Two authenticated handshakes, two rooms to join, and two things to
// remember to disconnect -- for a page that shows at most one running job.
//
// Created lazily so that pages which never touch the socket (Ready, Solved,
// Error) do not open a connection at all.

import { io } from "socket.io-client";

let socket = null;

export function getSocket() {
  if (socket === null) socket = io();
  return socket;
}

export function closeSocket() {
  if (socket !== null) {
    socket.disconnect();
    socket = null;
  }
}
